import React, { useEffect } from "react";
import { commonServices } from "../../../../api/services/commonServices";
import { userService } from "../../../../api/services/userService";
import { useAppSelector } from "../../../../infra/hooks";

interface PropsPayout {
  setPayoutTypes: (data: []) => any;
  setBank_Fields: (data: any) => void;
  setExchange_Fields: (data: any) => void;
  setAll_Bank_Names: (data: any) => void;
  setAll_Exchange_Names: (data: any) => void;
}
function DTOBankDetailModal({
  setPayoutTypes,
  setBank_Fields,
  setExchange_Fields,
  setAll_Bank_Names,
  setAll_Exchange_Names,
}: PropsPayout) {
  const selector = useAppSelector((state) => state.authSlice);
  useEffect(() => {
    userService.getPayoutTypes().then((res: any) => {
      if (res?.response == "success") {
        setPayoutTypes(res?.data);
      }
    });
    commonServices
      .getPayoutBankFields(selector.company_id)
      .then((res: any) => {
        setBank_Fields(res?.data);
      })
      .catch((err) => console.log(err));
    commonServices
      .getPayoutExchangeFields(selector.company_id)
      .then((res: any) => {
        setExchange_Fields(res?.data);
      })
      .catch((err) => console.log(err));
    commonServices
      .getBankNameList(selector.company_id)
      .then((res: any) => {
        setAll_Bank_Names(res?.data?.BankList);
        setAll_Exchange_Names(res?.data?.ExchangeList);
      })
      .catch((err) => console.log(err));
  }, []);
  return <></>;
}
export default DTOBankDetailModal;
